export function isPromise<T>(obj: T | Promise<T>): obj is Promise<T> {
    // @ts-ignore
    return obj != undefined && typeof obj["then"] === "function";
}
